function sanityCheck(fileType, url) {
    return `${fileType}/${url.substring(url.lastIndexOf('/') + 1)}`;
}

export {
    sanityCheck,
};
